"use client"

import ReactMarkdown from "react-markdown"
import { cn } from "@/lib/utils"
import type { ChatMessage } from "@/hooks/use-chat"

interface ChatBubbleProps {
  message: ChatMessage
}

export function ChatBubble({ message }: ChatBubbleProps) {
  const isUser = message.role === "user"

  return (
    <div className={cn("flex w-full", isUser ? "justify-end" : "justify-start")}>
      {isUser ? (
        <div className="lcw-msg lcw-msg--user">
          <p>{message.content}</p>
        </div>
      ) : (
        <div className="lcw-msg lcw-msg--bot">
          <ReactMarkdown>{message.content}</ReactMarkdown>
          {message.isStreaming && (
            <span className="inline-block ml-0.5 animate-pulse text-green-600">
              ▍
            </span>
          )}
        </div>
      )}
    </div>
  )
}
